import React, { useContext } from "react";

// styling
import "./style.scss";

// material ui icons
import CreateIcon from "@material-ui/icons/Create";

// To use history
import { useHistory } from "react-router-dom";

// global state
import { StateContext, StateDispatchContext } from "../../AppStateContext";

const AddClassButton = () => {
  // consume global state
  const setState = useContext(StateDispatchContext);
  const state = useContext(StateContext);

  // consume history from react router
  const history = useHistory();

  const displayAddClassForm = () => {
    history.push("/console/Schema/new-schema/new-class");
    setState({
      ...state,
      schema: { ...state.schema, isAddClassPageDisplayed: true },
    });
  };

  return (
    <div
      id="schemaCreateOwnSchemaEmptyState"
      className={
        state.theme === "dark"
          ? "__decisionBoxDark __decisionBox"
          : "__decisionBoxLight __decisionBox"
      }
      onClick={displayAddClassForm}
    >
      <h3
        className={
          state.theme === "dark"
            ? "__decisionBoxHeaderDark"
            : "__decisionBoxHeaderLight"
        }
      >
        Add your first Class
      </h3>
      <CreateIcon
        style={{
          fontSize: "42",
          color: state.theme === "dark" ? "#e2e9ff" : "#122742",
        }}
      />
    </div>
  );
};

export default AddClassButton;
